module.exports = __webpack_public_path__ + "img/gentlemen-club-carousel-5.c159f1fc.png";